<template>
  <p v-bind="$attrs" class="text-h4">
    <slot></slot>
  </p>
</template>

<script>
export default {
}
</script>
